import React, { useState } from "react";

import { Col, Form, Input, Row, Button, Modal, message } from "antd";
import MasterSuiteViewTable from "./MasterSuiteDuplicateTable";
import {
  createNewMasterSuite,
  createNewMasterSuiteSteps,
} from "../../../service/mastersuite.service";
import { useUser } from "../../../context/UserContext";
import {
  changeCategoryKey,
  changeSubCategoryKey,
} from "../../../helper/string_helper";

function MasterSuiteDuplicateModal(props) {
  const { email } = useUser();
  const [displayName, setDisplayName] = useState("");
  const handleModalClose = () => {
    props.handleModal(false);
  };
  const onSave = () => {
    const enhancedData = props.existingData.map((item, index) => ({
      ...item,
      name: displayName,
      category: changeCategoryKey(item.categoryValue),
      subcategory: changeSubCategoryKey(item.subCategoryValue),
    }));
    if (!displayName || displayNamePresent) {
      message.error(
        !displayName
          ? "Display name cannot be blank."
          : "Display name already exists. Please choose another.",
      );
      return;
    }
    createNewMasterSuite(
      displayName,
      "comments implement",
      email,
      props.defaultEnvironment,
    ).then((response) => {
      createNewMasterSuiteSteps(enhancedData, displayName).then(
        (stepResponse) => {
          props.getAllLibraryData();
          message.success("Master Suite created successfully");
          props.handleModal(false);
          setDisplayName("");
        },
      );
    });
  };
  const displayNamePresent = props.libraryData.some(
    (item) => item.name.toLowerCase() === displayName?.toLocaleLowerCase(),
  );
  const onChangeDisplayName = (e) => {
    setDisplayName(e.target.value);
  };
  return (
    <div>
      <Modal
        centered
        width="90%"
        open={props.visible}
        destroyOnClose
        onCancel={handleModalClose}
        maskClosable={false}
        footer={[
          <Button key="save" onClick={onSave}>
            Save
          </Button>,
          <Button key="back" type="primary" onClick={handleModalClose}>
            Cancel
          </Button>,
        ]}
        style={{
          top: 20,
          boxShadow:
            "0 8px 16px rgba(0, 0, 0, 0.3), 0 8px 8px rgba(0, 0, 0, 0.2)",
          transform: "scale(1.01)",
          borderRadius: "10px",
        }}
      >
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <Row style={{ paddingBottom: "20px" }}>
            <p className="modal-header-text">Copy Master Suite</p>
          </Row>
          <Row>
            <Col span={6}>
              <p className="spec-modal-label">Display Name * </p>
            </Col>
            <Col span={18}>
              <Form layout="vertical">
                <Form.Item>
                  <Input
                    placeholder="display name"
                    value={displayName}
                    onChange={onChangeDisplayName}
                  />
                </Form.Item>
              </Form>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <p className="spec-modal-label">Default Environment * </p>
            </Col>
            <Col span={18}>
              <Input
                placeholder="default environment"
                value={props.defaultEnvironment}
                disabled={true}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "10px" }}>
            <Col span={24}>
              <MasterSuiteViewTable
                dataSource={props.existingData}
                environment={props.defaultEnvironment}
              />
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
}

export default MasterSuiteDuplicateModal;
